import { styled } from 'styled-components';

export const PlayerBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const TimeLabel = styled.span`
  font-size: 12px;
  color: #666;
  min-width: 32px;
`;
